import Datepicker from "react-datepicker";

const DatepickerField = ({
  field,
  form,
  ...props
}) => {
  // Exclude `value` from the spread: react-datepicker treats a string `value`
  // prop as an override that always wins over its own typed-input state,
  // which blocks manual typing until `selected` becomes a Date object.
  const { value, ...restField } = field;
  return (
    <div>
      <Datepicker
        dateFormat="dd.MM.yyyy"
        {...restField}
        selected={value ? new Date(value) : null}
        onChange={(val) => form.setFieldValue(field.name, val)}
      />
    </div>
  );
};
export default DatepickerField;
